import { axios } from '@/lib/axios';

export const getProduct = async (pId: number, groupId: number) => {
    const { data } = await axios.get(`v1/get-product-details/${pId}/${groupId}`);
    return data;
};
